// ignore-string-externalization

import styled, { css } from 'styled-components';
import {
  screenSmMin,
  screenXsMin,
  spacer8,
  spacer16,
  spacer24,
  spacer32,
  spacer48,
  spacer56,
  Type,
  heading1FontSize,
  heading1LineHeightSmall,
} from '@spotify-internal/encore-web';

export const ContentTitle = styled(Type.h1).attrs({
  variant: 'alto',
  weight: 'bold',
})`
  font-size: ${heading1FontSize};
  line-height: ${heading1LineHeightSmall};
  margin-top: ${spacer8};
  padding-bottom: ${spacer56};
`;

export const contentPadding = css`
  flex: 2;
  padding: ${spacer48};
  @media (max-width: ${screenSmMin}) {
    padding: ${spacer32} ${spacer24};
  }

  @media (max-width: ${screenXsMin}) {
    padding: ${spacer24} ${spacer16};
  }
`;

export const ContentBody = styled.div`
  max-width: 720px;
  flex: 2;
  ${contentPadding}
`;
